import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

//  http://wiki.xunlei.cn/pages/viewpage.action?pageId=138981203
export const rank_homepage = createAsyncThunk(
  'live/vip/vip_activity',
  async (arg, store: any) => {
    const resp = await http.post('/live/gift/gift_wall_rank', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

export interface InitialStateType {
  list: Array<any>
  own?: any
}

const initialState: InitialStateType = {
  list: [],
}

export const GiftWallRankSlice = createSlice({
  name: 'Animal_Lion',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(rank_homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default GiftWallRankSlice.reducer
export const GiftWallRankActions = GiftWallRankSlice.actions

export const useGiftWallRankState = () => {
  const data = useSelector((state) => {
    return state.Animal_Lion
  })
  return data
}
